module.exports = __webpack_public_path__ + "static/img/xc4.bb1c53d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xc4.jpg
// module id = iDd5
// module chunks = 0